/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Multilingual_BadgeInputs */



/**
* | output |
* | --- |
* | "Multilingual" |
*
* @param {Voice_Manager_Multilingual_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_multilingual_badge = /** @type {((inputs?: Voice_Manager_Multilingual_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Multilingual_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Multilingue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehrsprachig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Multilingue")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Многоязычный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Multilingüe")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("多语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("多言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बहुभाषी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Multilingue")
	return /** @type {LocalizedString} */ ("Multilingual")
});